var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBulletin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0z",
    transform: "translate(0 .75)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EFB726",
    d: "M35.754 3.435c.124 1.736-1.18 3.24-2.915 3.366-1.726.122-3.236-1.184-3.361-2.92C29.354 2.149 30.66.646 32.393.524c1.733-.125 3.236 1.178 3.36 2.912",
    transform: "translate(0 .75) translate(6 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M13.35 15.468c.06.83.227 1.63.487 2.381L1.487 32.092c-.828.956-1.235 2.18-1.146 3.442.09 1.265.667 2.416 1.627 3.246.955.83 2.177 1.236 3.44 1.146 1.264-.089 2.418-.666 3.246-1.622L21 24.062c.782.146 1.598.2 2.426.14 5.188-.369 9.108-4.89 8.739-10.079-.077-1.07-.333-2.113-.763-3.094-.16-.373-.503-.636-.907-.7-.402-.06-.808.09-1.075.396l-2.72 3.14c-.412.478-.99.764-1.622.81-.631.046-1.242-.157-1.72-.573-.99-.856-1.096-2.354-.238-3.344l2.719-3.136c.265-.307.358-.73.238-1.12-.12-.39-.43-.69-.821-.8-1.033-.282-2.097-.39-3.17-.312-5.186.37-9.106 4.89-8.735 10.078zm2.364-.17c-.275-3.883 2.66-7.267 6.54-7.544.116-.01.23-.016.346-.018l-1.273 1.468c-1.712 1.976-1.499 4.978.477 6.691.957.829 2.18 1.232 3.44 1.143 1.266-.088 2.42-.665 3.248-1.62l1.27-1.472c.018.116.029.23.039.346.274 3.883-2.66 7.27-6.544 7.548-3.879.278-7.265-2.66-7.543-6.542zm-2.821 7.258l2.096-2.418c.911 1.318 2.147 2.39 3.583 3.102l-2.097 2.421-3.582-3.105zm-9.375 14.43c-.477-.412-.765-.989-.81-1.622-.046-.63.157-1.242.57-1.717l8.062-9.298 3.582 3.105-8.06 9.296c-.414.48-.99.766-1.62.813-.633.043-1.244-.159-1.724-.577z",
    transform: "translate(0 .75) translate(6 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBulletin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_bulletin.4706a0440efb518286bd5debf1036e56.svg";